import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import useAntTable from "../../utils/useAntTable";
import dayjs from "dayjs";
import {Button, Checkbox, Form, message, Space} from "antd";
import {Link} from "react-router-dom";
import * as api from "../../apis/dealer";
import withAuth from "../../utils/withAuth";
import BaseDataSelect from "../../components/BaseDataSelect";
import {DealerStatusMapping} from "../../utils/constants";
import BaseDataDisplay from "../../components/BaseDataSelect/display";
import {dealerQualificationOptions, dealerStatusOptions} from "../../utils/searchOptions";
import Select from "../../components/Select";
import UploadModal from "../../components/UploadModal";
import {useRequest} from "ahooks";
import useQueryParam from "../../utils/useQueryParam";

const AddButton = withAuth('add', Button);
const SynButton = withAuth('synYunyigou', Button);

function Dealer() {

    const {tableProps, form, search, refresh} = useAntTable(api.getDealers, {selectTable: true})

    const [uploadModalOpen, setUploadModalOpen] = useState(false)

    useQueryParam((params) => {
        if (params.status != null) params.status = parseInt(params.status)
        form.setFieldsValue(params)
        refresh()
    })

    const {loading: loadingSyncYunyigou, run: runSyncYunyigou} = useRequest(api.synYunyigou, {
        manual: true,
        onSuccess() {
            message.success('配置成功');
            tableProps.rowSelection.onChange([], []);
        }
    })

    const {run: onImport, loading: importing} = useRequest(api.importDealers, {
        manual: true,
        onSuccess: () => {
            setUploadModalOpen(false)
            refresh()
        }
    });

    const handleSync = () => {
        const ids = tableProps.rowSelection.selectedRowKeys || [];
        runSyncYunyigou(ids)
    }

    const columns: StandardColumnsType = [
        {
            title: '客户编号/名称',
            dataIndex: 'customer',
            search: true,
            className: 'hidden',
        },
        {
            title: '客户编号',
            dataIndex: 'no',
        },
        {
            title: '客户名称',
            dataIndex: 'name',
        },
        {
            title: '销售地区',
            dataIndex: 'area',
            render: value => (<BaseDataDisplay name={'saleAreas'} value={value}/>),
            search: {
                valueRender: (<BaseDataSelect name={'saleAreas'} nullLabel={'全部'}/>)
            },
        },
        {
            title: '集团',
            dataIndex: 'group',
            render: value => value ? (<BaseDataDisplay name={'groups'} value={value}/>) :
                <span>&nbsp;&nbsp;&nbsp;</span>,
            search: {
                valueRender: (<BaseDataSelect name={'groups'} nullLabel={'全部'}/>)
            },
        },
        {
            title: '客户性质',
            dataIndex: 'property',
            render: value => (<BaseDataDisplay name={'dealerNatures'} value={value}/>),
        },
        {
            title: '创建日期',
            dataIndex: 'createTime',
            render: (time) => dayjs(time).format('ll'),
        },
        {
            title: '客户状态',
            dataIndex: 'status',
            render: value => DealerStatusMapping[value],
            search: {
                valueType: 'select',
                valueEnum: dealerStatusOptions
            },
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <Link to={'/customer/dealer/detail/' + record.id}>详情</Link>
                </span>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'qualification',
            title: '资质',
            search: {
                valueType: 'select',
                valueEnum: dealerQualificationOptions
            }
        },
        {
            dataIndex: 'businessUser',
            title: '商务人员',
            search: {
                valueRender: () => (
                    <Select allowClear url={'/user/dict'} getData={data => data.data} textField={'nickName'}
                            value={'id'}/>
                )
            }
        },
        {
            dataIndex: 'salesUser',
            title: '销售人员',
            search: {
                valueRender: () => (
                    <Select allowClear url={'/user/dict'} getData={data => data.data} textField={'nickName'}
                            value={'id'}/>
                )
            }
        },
        {
            dataIndex: 'expirationUpcoming',
            title: '证书',
            search: {
                valueType: 'check',
                valueRender: () => (
                    <Checkbox>30天内证书到期客户</Checkbox>
                )
            }
        },
        {
            dataIndex: 'thisWeekNew',
            title: '本周新增客户',
            search: {
                valueType: 'check',
                valueRender: () => (
                    <Checkbox></Checkbox>
                )
            }
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} extSearchColumns={extSearchColumns} form={form}
                           search={search} scroll={{x: 'max-content'}} {...tableProps} toolbar={(
                <Space>
                    <SynButton type={"primary"} onClick={handleSync}>同步云医购</SynButton>
                    <Link to={'/customer/dealer/detail/'}><AddButton type={'primary'}>新增</AddButton></Link>
                    <AddButton type={'primary'} onClick={() => setUploadModalOpen(true)}>导入</AddButton>
                </Space>
            )}/>
            <UploadModal title={'客户导入'}
                         template={'/template/客户数据导入模板.xlsx'}
                         open={uploadModalOpen}
                         onCancel={() => setUploadModalOpen(false)}
                         confirmLoading={importing}
                         onUpload={onImport}/>
            <Form form={form}>
                <Form.Item noStyle name={'expirationUpcoming'}></Form.Item>
                <Form.Item noStyle name={'status'}></Form.Item>
                <Form.Item noStyle name={'thisWeekNew'}></Form.Item>
            </Form>
        </PageHeaderLayout>
    )
}

export default Dealer
